import { render, staticRenderFns } from "./AdministratorDetails.vue?vue&type=template&id=693c95ca&scoped=true&"
import script from "./AdministratorDetails.vue?vue&type=script&lang=js&"
export * from "./AdministratorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693c95ca",
  null
  
)

export default component.exports